import { CUIColors } from '@dotcom/crown-ui';

const basicTextColors: string[] = [
  CUIColors.Black, // Default US text color
  'dark-charcoal', // Default UK text color
  'gray',
  'royal-blue',
  'dark-turquoise',
  'bright-purple',
  'ivory',
];

export const extendedTextColors: string[] = basicTextColors.concat([
  'rust-red',
  'light-rose',
  'white-1',
  'orange',
  'bright-yellow',
  'dijon-yellow',
  'gold',
  'tan',
  'forest-green',
  'watercourse-green',
  'lime',
  'sage-green',
  'mint',
  'navy',
  'teal-blue',
  'aquamarine-blue',
  'dark-purple',
  'dusty-lilac',
  'blush-pink',
  'maroon',
  'red',
  'magenta-pink',
  'bubble-gum-pink',
  'coral-pink',
]);
